import { clone, map, isPlainObject } from 'lodash';

import { tomorrow } from '../../utils/dates';

export class OfferBase {
  id = '';
  name = '';
  status = '';
  start_date = null;
  reference = '';
  publication_date = tomorrow('UTC').toISOString();
  created_at = '';
  end_date = null;
  picture = null;
  is_activated = true;
  last_publish = null;
  old_publication_dates = [];
  legal_terms: string;
  completion = null;
  type = '';
  brand: any = null;
  network: any = null;
  stores: any = [];
  targeting_filters: any = [];
  user: any;
  application_url = null;
  application_channel = 'BOTH';
  description = '';
  segments: any = [];
  deep_link_url: string;

  getActiveStatus() {
    if (this.is_activated && new Date(this.start_date) > new Date()) {
      return 'NOT_STARTED';
    }

    if (this.is_activated && new Date(this.end_date) < new Date()) {
      return 'ENDED';
    }

    if (this.is_activated && new Date(this.start_date) <= new Date()) {
      return 'ACTIVE';
    }

    if (!this.is_activated) {
      return 'INACTIVE';
    }

    return '';
  }

  trimTimezoneFromDates() {
    [ 'start_date', 'end_date', 'publication_date' ].forEach((key) => {
      const value = this[key];

      if (value) {
        this[key] = value.substring(0, 19) + 'Z';
      }
    });
  }
}

export function toApi(data) {
  data = clone(data);

  if (data.user && data.user.id) {
    data.user = data.user.id;
  }

  if (data.merchant && data.merchant.id) {
    data.merchant = data.merchant.id;
  }

  if (data.picture && data.picture.id) {
    data.picture = data.picture.id;
  }

  if (data.brand && data.brand.id) {
    data.brand = data.brand.id;
  }

  if (data.start_date) {
    const startDate = new Date(data.start_date);
    startDate.setUTCHours(0, 0, 0, 0);
    data.start_date = startDate;
  }

  if (data.end_date) {
    const endDate = new Date(data.end_date);
    endDate.setUTCHours(23, 59, 59, 999);
    data.end_date = endDate;
  }

  if (!data.application_url) {
    data.application_url = null;
  }

  return data;
}

export function handleDuplicateOfferData(offer: any) {
  offer.id = null;
  offer.reference = null;
  offer.start_date = null;
  offer.end_date = null;
  offer.name = '[Copy] ' + offer.name;
  offer.publication_date = null;

  if (offer.segments) {
    offer.segments = offer.segments.map((segment) => segment.id ? segment.id : segment);
  }
}
